import React, { useContext, useState, useEffect } from "react";
import {
  Grid,
  Card,
  CardContent,
  Box,
  Skeleton,
  Typography,
  Tooltip
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { useLocation, useNavigate } from "react-router-dom";
// import { fontFamilyAll,COLORS} from "../../assets/commonComponents/COLORS";
import { primaryColor,fontFamilyAll,secondaryColor, lightgreyColor } from "../UtilColor";
// import {lightgreenColor} from "../../assets/commonComponents/COLORS/COLORS"
// import { fontFamilyAll, primaryColor,lightgreenColor } from "../UtilColorPalette/UtilColorPalette";
import { KnowledgeBaseContext } from "../../Compoenets/knowledgeBaseContext/KnowledgeBaseContext";
import SearchOffIcon from "@mui/icons-material/SearchOff";
import UtilHeader from "../UtilHeader/UtilHeader"
// ---------------- Styled Components ---------------- //
const StyledCard = styled(Card)(({ theme }) => ({
  width: 300,
  height: 170,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  transition: "transform 0.25s ease, box-shadow 0.25s ease",
  borderRadius: theme.shape.borderRadius * 2,
  cursor: "pointer",
  "&:hover": {
    transform: "translateY(-4px)",
    boxShadow: theme.shadows[6],
  },
}));

const StyledSkeletonCard = styled(Card)(({ theme }) => ({
  width: 300,
  height: 170,
  borderRadius: theme.shape.borderRadius * 2,
}));

const EmptyState = () => (
  <Grid item xs={12}>
    <Box
      sx={{
        textAlign: "center",
        fontFamily: fontFamilyAll,
        color: "gray",
        mt: 12,
        p: 5,
        // backgroundColor: "whitesmoke",
        borderRadius: 3,
      }}
    >
      <Box
        sx={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          width: 80,
          height: 80,
          borderRadius: "50%",
          backgroundColor: "#f5f5f5",
          mb: 2,
        }}
      >
        <SearchOffIcon sx={{ fontSize: 40, color: "gray" }} />
      </Box>
      <Typography variant="h6" sx={{ fontWeight: 600 }} fontFamily={fontFamilyAll}>
        No search results found
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }} fontFamily={fontFamilyAll}>
        Try adjusting your search or use different keywords.
      </Typography>
    </Box>
  </Grid>
);

// ---------------- Main Component ---------------- //
const BusinessToolsCards = () => {
  const navigate = useNavigate();
  const {
    categories=[],
    setCategoryId,
    setCategoryName,
    articles,
    searchString,
    setSelectedRecordid,
    setSelectedCategoryName
  } = useContext(KnowledgeBaseContext);

  const [loading, setLoading] = useState(true);
  // const location = useLocation();

  useEffect(() => {
    if (categories?.length > 0) {
      setLoading(false);
    }
  }, [categories]);

  const handleCardClick = (item) => {
    if (searchString && item.noofarticles!=1) {
      navigate(`/knowledgebase/article/${searchString}/${item.recordid}`)
      setSelectedCategoryName(item.name)
    }
    else {
      navigate(`/knowledgebase/document/${item.articles[0]?.articleId}`);
      setCategoryId(item.recordid);
      setCategoryName(item.name);

      if (item.articles?.length > 0) {
        const firstArticleId = item.articles[0].articleId;
        const articleResponse = articles.find(
          (article) => article.recordid === firstArticleId
        );
        setSelectedRecordid(articleResponse?.recordid || null);
      }
    }

  };

  if (categories?.length === 0 && searchString) return <EmptyState />;

  return (
    <Box sx={{ mt: "120px" }}>
      
      <Grid
        container
        spacing={6}
        sx={{ backgroundColor:lightgreyColor, p: 4 }}
        justifyContent="center"
      >
        {loading
          ? Array.from(new Array(8)).map((_, index) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
              <StyledSkeletonCard>
                <CardContent sx={{ p: 2 }}>
                  <Skeleton
                    variant="rectangular"
                    width="100%"
                    height={20}
                    sx={{ mb: 1, borderRadius: 1 }}
                  />
                  <Skeleton
                    variant="rectangular"
                    width="100%"
                    height={50}
                    sx={{ borderRadius: 1 }}
                  />
                </CardContent>
              </StyledSkeletonCard>
            </Grid>
          ))
          : categories
            ?.filter((item) => item.isactive)
            ?.map((item, index) => (
              <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                <StyledCard onClick={() => handleCardClick(item)}>
                  <CardContent sx={{ p: 2 }}>
                    {/* Header */}
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                      <Typography
                        sx={{ fontFamily: fontFamilyAll, fontWeight: 600,textAlign:"left" }}
                      >
                        {item.name}
                      </Typography>
                      <Typography
                        sx={{
                          fontFamily: fontFamilyAll,
                          color: "text.secondary",
                          fontSize: 12,
                        }}
                      >
                        {item.noofarticles > 0 &&
                          `${item.noofarticles} ${item.noofarticles === 1 ? "Article" : "Articles"
                          }`}
                      </Typography>
                    </Box>

                    {/* Description */}
                  <Tooltip title={item.description || ""} arrow placement="bottom">
                        <Typography
                          variant="body2"
                          sx={{ mt: 1, fontFamily: fontFamilyAll }}
                          textAlign={"justify"}
                        >
                          {item.description
                            ? `${item.description.slice(0, 100)}...`
                            : ""}
                        </Typography>
                      </Tooltip>

                    {/* Articles (when searching) */}
                    {/* {searchString && item.articles?.length > 0 && (
                      <Box
                        sx={{
                          mt: 1,
                          fontFamily: fontFamilyAll,
                          fontSize: 13,
                          display: "grid",
                          gridTemplateColumns: "repeat(2, 1fr)",
                          gap: "6px",
                        }}
                      >
                        {item.articles.slice(0, 5).map((article, idx) => (
                            <Box
                              key={idx}
                              component="span"
                              sx={{
                                color: primaryColor,
                                cursor: "pointer",
                                textDecoration: "none",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                              onClick={(e) => {
                                e.stopPropagation();
                                navigate(`/document/${article.articleId}`);
                                setSelectedRecordid(article.articleId);
                                setCategoryId(item.recordid);
                                setCategoryName(item.name);
                              }}
                            >
                              {article.articleName}
                            </Box>
                          ))}

                    
                        {item.articles.length > 5 && (
                            <Box
                              component="span"
                              sx={{
                                color: "gray",
                                cursor: "pointer",
                                fontStyle: "italic",
                              }}
                              onClick={(e) => {
                                e.stopPropagation();
                                navigate(`/article/${item.recordid}`);
                              
                              }}
                            >
                              + More...
                            </Box>
                          )}
                      </Box>
                    )} */}
                  </CardContent>
                </StyledCard>
              </Grid>
            ))}
      </Grid>
    </Box>
  );
};

export default BusinessToolsCards;
